import { Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import { getClientChartHrefForMessagingParticipant } from '../services/messagingFhir';
import classes from './ThreadView.module.css';

export interface MessagingParticipantNameProps {
  display: string;
  reference?: string;
  /** When true, names render as plain text (client portal users). */
  isViewerClient: boolean;
  fw?: React.CSSProperties['fontWeight'];
  size?: string;
}

/**
 * Renders a messaging participant name. Staff can open client charts from Patient refs;
 * clients always see non-interactive names.
 */
export function MessagingParticipantName({
  display,
  reference,
  isViewerClient,
  fw,
  size = 'sm',
}: MessagingParticipantNameProps): JSX.Element {
  const href = getClientChartHrefForMessagingParticipant(reference, isViewerClient);

  if (href) {
    return (
      <Text
        component={Link}
        to={href}
        size={size}
        fw={fw}
        className={classes.participantLink}
        aria-label={`View chart for ${display}`}
      >
        {display}
      </Text>
    );
  }

  return (
    <Text size={size} fw={fw}>
      {display}
    </Text>
  );
}
